import { useRef } from "react";
import { Table, TableFooter } from "@mui/material"
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from "moment";
import StatusDropdown from "./status-dropdown";
import { useNavigate, useParams } from "react-router-dom";

export default function EnquiryTable({ children, results, updateStatus, currentPage, pageSize }) {
  const { vendorId } = useParams();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const formatRelativeTime = (timestamp) => {
    return timestamp ? moment(timestamp).fromNow() : "--";
  };

  const isWithin15Minutes = (timestamp) => {
    return timestamp
      ? moment().diff(moment(timestamp), "minutes") <= 15
      : false;
  };

  /**@NavigationOverviewHandler */
  const enquiryOverviewHandler = (data) => {
    navigate(`/vendor-enquiry-overview?vendorId=${vendorId}&enquiryId=${data?._id}`, {
      state: {
        selectedEnquiryDetails: data
      }
    })
  }

  return (
    <div ref={dropdownRef}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{
              '& th': {
                fontWeight: '600',
                py: 2,
                px: 3,
                backgroundColor: "#fafafa "
              },
            }}
            >
              <TableCell>SNo</TableCell>
              <TableCell>Customer name</TableCell>
              <TableCell>Event type</TableCell>
              <TableCell>Venue name</TableCell>
              <TableCell>Event date</TableCell>
              <TableCell>Guest</TableCell>
              <TableCell>Budget</TableCell>
              <TableCell>Last Message</TableCell>
              <TableCell>Status</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              results?.map((data, index) => (
                <TableRow key={index} className={`py-1 ${index % 2 === 0 && "bg-neutral-100"}`}>
                  <TableCell>{ (((currentPage ?? 1 ) - 1) * pageSize) + (index + 1)}</TableCell>
                  <TableCell>{data?.customerId?.fullName}</TableCell>
                  <TableCell>{data?.eventType}</TableCell>
                  <TableCell>{data?.venueName || data?.hotelName}</TableCell>
                  <TableCell>{data?.startDate}</TableCell>
                  <TableCell>{data?.guests}</TableCell>
                  <TableCell>AED {data?.budget || "--"}</TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <div
                        className={`bg-[#D03660] rounded-full w-2 ${isWithin15Minutes(data?.lastMessage?.time)
                          ? "visible mr-2 h-2"
                          : "invisible "
                          }`}
                      ></div>
                      {formatRelativeTime(data?.lastMessage?.time)}
                    </div>
                  </TableCell>
                  <TableCell>
                    <StatusDropdown
                    enquiry={data}
                    updateStatus={updateStatus}
                    ref={dropdownRef}
                    // user={user}
                    />
                  </TableCell>
                  <TableCell onClick={() => enquiryOverviewHandler(data)}>
                    <img src="/rightarrow.svg" alt="right-arrow" />
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
          <TableFooter>
            <TableRow>
            <TableCell colSpan={10} align="right">
              {children}
            </TableCell>
          </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  )
}